import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserProfileService } from '../../../services/user-profile.service';
import { ITpUserSettings } from 'ngx-register-base';
import { UzuPageMenuStore } from './store/store';

export const SIDE_MENU_STATE_LOCAL_STORAGE = 'sideMenuCachedState';

@Injectable({
  providedIn: 'root',
})
export class MenuStateService {
  private readonly _isOpen$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public readonly isOpen$: Observable<boolean> = this._isOpen$.asObservable();
  private savedSettings?: ITpUserSettings;
  private readonly _pageMenuStore = inject(UzuPageMenuStore);
  private readonly _ups = inject(UserProfileService);

  constructor() {
    this._subscribeOnSavedState();
  }

  public setOpen(value: boolean): void {
    this._isOpen$.next(value);
  }

  public get isOpen(): boolean {
    return this._isOpen$.value;
  }

  public toggle(): void {
    const state = !this.isOpen;

    this.setOpen(state);
    this._saveCachedState(state);
    this._pageMenuStore.upsertMenuState(state);
  }

  private _saveCachedState(isOpen: boolean): void {
    localStorage.setItem(SIDE_MENU_STATE_LOCAL_STORAGE, String(isOpen));
  }

  private _loadCachedState(): boolean | undefined {
    const state = localStorage.getItem(SIDE_MENU_STATE_LOCAL_STORAGE);
    if (state) {
      return state === 'true';
    }

    return undefined;
  }

  private _subscribeOnSavedState(): void {
    this._pageMenuStore.menuStateSettings$.subscribe((settings: ITpUserSettings | undefined) => {
      const cachedState = this._loadCachedState();
      this.savedSettings = settings;
      const menuState = cachedState || (this.savedSettings?.settings?.menuState ?? true);

      if (menuState !== this.isOpen) {
        this.setOpen(menuState);
      }
    });

    const userId = this._ups.getUserProfile().id;
    this._pageMenuStore.queryMenuState(userId);
  }
}
